export const RCM_ALL_CLASSIFICATION_FILTER_OPTIONS = [
  { label: 'Classification (All)', value: 'all' },
  { label: 'Business', value: 'business' },
  { label: 'ITGC', value: 'itgc' },
];
